// Smoothly scroll the anchor into view after the dialog begins closing
export const scrollToAnchor = (anchorId, timeoutMs = 3000) => {
  const deadline = Date.now() + timeoutMs;

  const tryScroll = () => {
    const el = document.getElementById(anchorId);
    if (el) {
      const prefersReduced =
        window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;

      if (typeof el.scrollIntoView === "function") {
        el.scrollIntoView({
          behavior: prefersReduced ? "auto" : "smooth",
          block: "start",
          inline: "nearest",
        });
      }
      if (typeof el.animate === "function") {
        el.animate(
          [
            {
              outline: "3px solid #ff00ff",
              "outline-offset": "2px",
              "background-color": "rgba(255,255,0,0.35)",
              "box-shadow":
                "0 0 0 4px rgba(255,0,255,0.35) inset, 0 0 0 6px rgba(255,0,255,0.25)",
            },
            {
              outline: "0 solid transparent",
              "outline-offset": "2px",
              "background-color": "transparent",
              "box-shadow": "none",
            },
          ] as any,
          {
            duration: 400,
            easing: "ease-in-out",
            direction: "alternate",
            iterations: 5,
          }
        );
      }
      return;
    }
    if (Date.now() < deadline) setTimeout(tryScroll, 100); // check again in 100ms
  };

  // let the dialog begin closing, then start polling
  setTimeout(tryScroll, 0);
};
